import React, { Component } from 'react'
import {List, Flex, Toast} from 'antd-mobile'
import { ORG_CODE, FARM_ORG } from '../../cache'
import Breeder from './components/breeder'
import MateGroup from './components/mate-group'
import LinkText from './components/link'
import PreBirthWeek from './components/pre-birth-week'

import './index.css'
import {createForm} from 'rc-form';
import Table from '../../components/Table';
import send from '../../utils/send';
import EmptyReport from "../../components/EmptyReport";
let breedersSource = [];
let birthWeekSource = [];
class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPreWeek: false,
      showBirthWeek: false,
      showBreeder: false,
      selectedBreeder: [],
      allBreed: 'ALL',
      birthWeek: '',
      startData: '',
      endData: '',
      bw1: 4,
      bw2: 8,
      bw3: 16,
      bw4: 26,
      check1: true,
      check2: true,
      check3: true,
      check4: true,
      tableData: [],
      columns: [
        {
          id: 'breeder',
          title: '按期间分析',
          align: 'left',
          fixed: true,
          render: (data) => {
            if (data['sub_category_name_loc']) {
              return <div style={{width: 100}}>{data['sub_category_name_loc']}</div>
            } else {
              return ''
            }
          }
        },
        {
          id: 'column_traget_02',
          title: '目标值',
          align: 'left'
        }
      ]
    }
  }
  changeBreeder = () => {
    const {showBreeder} = this.state;
    this.setState({
      showBreeder: !showBreeder,
      showBirthWeek: false,
      showPreWeek: false
    })
  };
  onCancel = () => {
    this.setState({
      showBreeder: false
    })
  };
  doSearch = () => {
    Toast.loading('请稍等', 0);
    const {check1, check2, check3, check4, bw1, bw2, bw3, bw4, selectedBreeder, allBreed, endDate} = this.state;
    let b1 = check1 ? Number(bw1) : 0;
    let b2 = check2 ? Number(bw2) : 0;
    let b3 = check3 ? Number(bw3) : 0;
    let b4= check4 ? Number(bw4) : 0;
    let parPeriodWeeks= `1#${b1}#${b2}#${b3}#${b4}`;
    let parEndBreed = selectedBreeder.toString();
    if (allBreed === 'ALL') {
      parEndBreed = '99'
    }
    send({
      url: '/api/forward/ifarm/report1',
      method: 'POST',
      data: {
        farmOrg: FARM_ORG,
        orgCode: ORG_CODE,
        parAllBreed: allBreed,
        parDate: endDate,
        parPeriodWeeks: parPeriodWeeks,
        parEndBreed: parEndBreed,
        parStartBreed: '00'
      }
    })
      .then(res => {
        let tableData = res.data;
        let columns = [
          {
            id: 'breeder',
            title: '按期间分析',
            align: 'left',
            fixed: true,
            render: (data,index) => {
              if (tableData[index]['sub_category_name_loc']) {
                let rang = ['10.1000', '20.0000', '20.1000', '30.0000','30.1000','40.0000','40.1000'];
                let fontWeight = rang.indexOf(tableData[index].sub_category) >= 0 ? '700' : '400';
                let color = rang.indexOf(tableData[index].sub_category) >= 0 ? '#000' : '#666';
                return <div style={{width: 100,fontWeight, color}}>{tableData[index]['sub_category_name_loc']}</div>
              } else {
                return ''
              }
            }
          },
          {
            id: 'column_traget_02',
            title: '目标值',
            render: (d, index) => {
              let rang = ['10.1000', '20.0000', '20.1000', '30.0000','30.1000','40.0000','40.1000'];
              if (rang.indexOf(tableData[index].sub_category) >= 0) {
                return ''
              } else {
                return <div style={{width: 60}}>{tableData[index]['column_traget_02']}</div>
              }
            }
          },
          {
            id: 'date_column_01_min_date', // 因column_1 无值报错 故使用此值
            width: 100,
            title: `${tableData[0]['date_column_01_min_date']} ${tableData[0]['date_column_01_max_date']}`,
            render: (d, index) => {
              let rang = ['10.1000', '20.0000', '20.1000', '30.0000','30.1000','40.0000','40.1000'];
              if (rang.indexOf(tableData[index].sub_category) >= 0) {
                return ''
              } else {
                return <div style={{width: 80}}>{tableData[index]['column_1']}</div>
              }
            }
          }
        ];
        let ids = [];
        let headers = [];
        for (var i = 2; i < 6; i++) {
          let id1 = `column_acm_0${i}`;
          let id2 = `column_avg_0${i}`;
          let str1 = `date_column_acc_0${i}_header`;
          let str2 = `date_column_avg_0${i}_header`;
          ids.push(id1, id2);
          headers.push(str1, str2)
        }
        console.log(headers);
        for (var num = 0; num < 10; num++) {
          let id = ids[num];
          console.log(headers[num]);
          let title = tableData[0][headers[num]];
          if (!title) {
            // 没有返回当前的表头，则不渲染该列
            continue
          }
          columns.push(
            {
              id: id,
              title: title,
              render: (d, index) => {
                let rang = ['10.1000', '20.0000', '20.1000', '30.0000','30.1000','40.0000','40.1000'];
                if (rang.indexOf(tableData[index].sub_category) >= 0) {
                  return ''
                } else {
                  return tableData[index][id]
                }
              }
            }
          )
        }
        this.setState({
          tableData: tableData,
          columns: [...columns]
        }, () => {
          Toast.hide()
        })
      })
      .catch(err => {
        console.log(err)
      })
  };
  async componentDidMount() {
    let breed = await send({
      url: '/api/forward/ifarm/breedTypeByOrg',
      method: 'GET',
      params: {
        orgCode: ORG_CODE
      }
    });
    let birthWeek = await send({
      url: '/api/forward/ifarm/getWeekYearly',
      method: 'GET'
    });
    // 获取品种， 周次的信息，并默认初始值。得到之后，查询。
    breedersSource = breed.data.filter(o => o.PRODUCTID !== 'TOTAL');
    birthWeekSource = birthWeek.data;
    this.setState({
      selectedBreeder: breedersSource.map(o => o.PRODUCTID),
      allBreed: 'ALL',
      birthWeek: birthWeekSource[0].mateGroup,
      startDate: birthWeekSource[0].weekStartDate,
      endDate: birthWeekSource[0].weekEndDate
    }, () => {
      this.doSearch()
    })
  }
  render() {
    const {showBirthWeek,showBreeder,showPreWeek,selectedBreeder,birthWeek,startDate, endDate, bw1, bw2, bw3, bw4, check1, check2, check3, check4} = this.state;
    return (
      <React.Fragment>

        <div className="oneH">
          <List>
            <Flex className={showBreeder|| showBirthWeek || showPreWeek ? 'single-multi-menu-active' : ''}>
              <Flex.Item className={'single-multi-top-nav-bar'}>
                <List.Item onClick={this.changeBreeder}>
                  <LinkText show={showBreeder}>品种</LinkText>

                </List.Item>
              </Flex.Item>
              <Flex.Item className={'single-multi-top-nav-bar'}
                  style={{marginLeft: 0}}
              >
                <List.Item onClick={() => {
                  this.setState({
                    showBirthWeek: !showBirthWeek,
                    showBreeder: false,
                    showPreWeek: false
                  })}
                }
                >
                  <LinkText  show={showBirthWeek}>周次</LinkText>

                </List.Item>
              </Flex.Item>
              <Flex.Item className={'single-multi-top-nav-bar '}
                  style={{marginLeft: 0}}
              >
                <List.Item onClick={() => {
                  this.setState({
                    showBirthWeek: false,
                    showBreeder: false,
                    showPreWeek: !showPreWeek
                  })
                }}
                >
                  <LinkText show={showPreWeek}>后退周次</LinkText>

                </List.Item>
              </Flex.Item>
            </Flex>
          </List>
          {
            showBreeder ? <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
              <Breeder data={breedersSource}
                  onCancel={this.onCancel}
                  onConfirm={(value, desc) => {
                         this.setState({
                           showBreeder: false,
                           selectedBreeder: value,
                           allBreed: desc
                         }, () => {
                           this.doSearch()
                         });
                       }}
                  value={selectedBreeder}
              />
            </div>: null
          }
          {
            showBirthWeek ? <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
              <MateGroup data={birthWeekSource}
                  onCancel={() => {
                           this.setState({
                             showBirthWeek: false
                           })}
                         }
                  onConfirm={(value, obj) => {
                           this.setState({
                             birthWeek: value,
                             endDate: obj.weekEndDate,
                             startDate: obj.weekStartDate,
                             showBirthWeek: false
                           }, () => {
                             this.doSearch()
                           })
                         }}
                  value={birthWeek}
              />
            </div>: null
          }
          {
            showPreWeek && <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
              <PreBirthWeek onCancel={() => {
                this.setState({
                  showPreWeek: false
                })}
              }
                  onConfirm={(value) => {
                              this.setState({
                                ...value,
                                showPreWeek: false
                              }, () => {
                                this.doSearch()
                              })
                            }}
                  value={{bw1, bw2, bw3, bw4, check1, check2, check3, check4}}
              />
            </div>
          }
          <List.Item className="span-4"
              extra={`${startDate|| ''} ~ ${endDate || ''}`}
          >周次时间</List.Item>

          {this.state.tableData.length > 0 ? <div>
            <Table columns={this.state.columns}
                   data={this.state.tableData}
                   stripe
            />

          </div> : <EmptyReport height={250} width={'100vw'} />}
        </div>
        {showBirthWeek || showBreeder || showPreWeek ? <div className="menu-mask"
            onClick={() => {this.setState({showBreeder: false, showBirthWeek: false, showPreWeek: false})}}
                                                       /> : null}

      </React.Fragment>
    )
  }
}

export default createForm()(Report)
